var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 10.6666C10.6665 9.60576 11.1582 8.58834 12.0333 7.8382C12.9085 7.08805 14.0955 6.66663 15.3332 6.66663H16.6665C17.9042 6.66663 19.0912 7.08805 19.9663 7.8382C20.8415 8.58834 21.3332 9.60576 21.3332 10.6666C21.3823 11.5323 21.1488 12.3905 20.6678 13.1119C20.1868 13.8334 19.4845 14.379 18.6665 14.6666C17.8485 15.0501 17.1462 15.7776 16.6652 16.7396C16.1843 17.7015 15.9507 18.8457 15.9998 20M15.9998 25.3333V25.3466",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuestionMark);
export default __webpack_public_path__ + "static/media/ico_question-mark.86ed88edb3a40cad5112e1f9617a15eb.svg";
export { ForwardRef as ReactComponent };